export const useScrollToTop = (top = 0, behavior: any = 'smooth') =>
  window.scrollTo({ top, behavior })
